//
import axios from 'axios';
import { ref } from 'vue';
import { parseUrl, dataToSearchParams } from './url';

export function fetchAPI() {

    const data = ref(null);
    const error = ref(null);
    const loading = ref(false);
    const searchParams = ref(null);
    const paramsData = ref({});

    const fetchData = async(
        {
            url = window.location.href,
            method = 'get',
            data = {},
            params = {},
        } = {},
        onSuccess,
        onFailure,
        onAlways
    ) => {

        loading.value = true;
        error.value = null;
        let qs = {};
        let response;

        try {

            qs = Object.keys(params).length === 0 ?
                parseUrl(window.location.href) :
                params;

            searchParams.value = dataToSearchParams(qs);
            paramsData.value = JSON.parse(JSON.stringify(qs));

            const opts = {
                url: url,
                method: method
            };

            switch (new String(method).toLowerCase()) {
                case 'post':
                case 'patch':
                case 'delete':
                    opts.data = data;
                    break;
                default:
                    opts.params = qs;
            };

            response = await axios(opts);
            data.value = response.data;

            if (typeof onSuccess === 'function') {
                onSuccess(response.data);
            }

        } catch (err) {
            //console.log('catch', err);
            error.value = err;
            console.error(err);

            if (typeof onFailure === 'function') {
                onFailure(err);
            }
        } finally {
            loading.value = false;
            if (typeof onAlways === 'function') {
                //console.log('always', response);
                onAlways(response?.data);
            }
        }
    };

    return {
        data,
        loading,
        paramsData,
        searchParams,
        fetchData,
    };
};
